export const BlueArrow = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--blue-arrow';
  color = color || '#0076CC';

  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M12.0986 5.06689L5.43188 11.7336"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.0979 5.06689H12.0979V11.0669"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BlueArrow;
